const selectColorForEvents: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#AE4824",
    buttonColor: "#C1692F",
  },
  {
    color: "#C13333",
    buttonColor: "#7E2020",
  },
  {
    color: "#FFAC38",
    buttonColor: "#1F3537",
  },
  {
    color: "#1A5089",
    buttonColor: "#14336C",
  },
  {
    color: "#32346D",
    buttonColor: "#B56363",
  },
  {
    color: "#006666",
    buttonColor: "#004747",
  },
];

export default selectColorForEvents;
